<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Profitability-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="searchara"
                label=" Ara"
                append-icon="search"
              >
              </v-text-field>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title> {{$t('Profitability-Report')}}  Excel</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListOzetExcel()">
                    <v-list-tile-title>
                      {{ $t('Profitability-Report-Summary-Excel') }}
                      </v-list-tile-title
                    >
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pl-1 pt-2 md2>
                        <v-select
                          :label="$t('Date-Type')"
                          items-value="value"
                          item-text="text"
                          :items="itemstarihtip"
                          v-model="tarihTip"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Starting-Date')"
                          :detaygizle="false"
                          :rules="[(v) => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla"
                          v-model="KayitTarihiBasla"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp
                          :etiket="$t('Finishing-Date')"
                          :detaygizle="false"
                          :rules="[(v) => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis"
                          v-model="KayitTarihiBitis"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <v-select
                          hide-details
                          :items="doviztipi"
                          v-model="Rapor.PPNR_ParaBirimi"
                          :rules="[(v) => !!v || 'Lütfen para birimi seçiniz']"
                          item-text="Title"
                          item-value="DovizKod"
                          :label="$t('Currency-Unit')"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <v-layout justify-center row full-width>
                          <v-radio-group row v-model="raporTipi">
                            <v-radio :label="$t('Detail-Report')" value="0"></v-radio>
                            <v-radio :label="$t('Summary-Report')" value="1"></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn
                              color="info"
                              @click="getList()"
                              fab
                              small
                              dark
                            >
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout row fill-height align-center>
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                              ></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green"
                                >check_circle_outline</v-icon
                              >
                            </template>

                            <v-btn
                              small
                              @mouseenter="tooltip = true"
                              @mouseleave="tooltip = false"
                              ref="fab"
                              @click="filtrele()"
                              color="info"
                              fab
                              dark
                            >
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 v-if="raporTipi == 0" md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table
                                :headers="headersdetay"
                                :rows-per-page-items="[20, 100]"
                                :items="itemsdetay"
                                :search="searchara"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td class="text-xs-center">
                                      {{ props.item.SirketNo }}
                                    </td>
                                    <td class="text-xs-center">
                                      {{ props.item.PNR_No }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.CariUnvan }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.SaticiAd }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Isim }}
                                    </td>
                                    <td class="text-xs-center">
                                      {{ props.item.Gece }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.SatisFaturaNo }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.SatisFaturaTarih }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.GelenFaturaNo }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.GelenFaturaTarih }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.IadeFaturaNo }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.IadeFaturaTarih }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.KomFaturaNo }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.KomFaturaTarih }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.SatisFaturaTutar
                                          | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.GelenFaturaTutar
                                          | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.IadeFaturaTutar | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.KomFaturaTutar | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.Kar_KDV_li | moneyformat }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.Kar_Yuzde_KDV_li
                                          | moneyformat
                                      }}
                                    </td>

                                    <!--      <td class="justify-start align-center full-heigth layout px-0">
                                  <v-tooltip bottom>
                                        <v-btn icon small slot="activator" flat @click="pnrIptalDialog(props.item)">
                                          <v-icon color="red">cancel</v-icon>
                                        </v-btn>
                                        <span>PNR {{$t("cancel_button")}}</span>
                                      </v-tooltip>
                                      <v-btn icon small slot="activator" flat @click="git(props.item)">
                                        <v-icon color="info">search</v-icon>
                                      </v-btn>
                                    </td>-->
                                  </tr>
                                </template>
                                <v-alert
                                  slot="no-results"
                                  :value="true"
                                  color="error"
                                  icon="warning"
                                >
                                         {{ $t('No-records-searched-for', { value: searchara}) }} 
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 v-if="raporTipi == 1" md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table
                                :headers="headersozet"
                                :rows-per-page-items="[20, 100]"
                                :items="itemsozet"
                                :search="searchara"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td class="text-xs-center">
                                      {{ props.item.SirketNo }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.CariUnvan }}
                                    </td>
                                    <td class="text-xs-center">
                                      {{ props.item.Gece }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.SatisFaturaTutar
                                          | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.GelenFaturaTutar
                                          | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.IadeFaturaTutar | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.KomFaturaTutar | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.Kar_KDV_li | moneyformat }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{
                                        props.item.Kar_Yuzde_KDV_li
                                          | moneyformat
                                      }}
                                    </td>

                                    <!--      <td class="justify-start align-center full-heigth layout px-0">
                                  <v-tooltip bottom>
                                        <v-btn icon small slot="activator" flat @click="pnrIptalDialog(props.item)">
                                          <v-icon color="red">cancel</v-icon>
                                        </v-btn>
                                        <span>PNR İptal</span>
                                      </v-tooltip>
                                      <v-btn icon small slot="activator" flat @click="git(props.item)">
                                        <v-icon color="info">search</v-icon>
                                      </v-btn>
                                    </td>-->
                                  </tr>
                                </template>
                                <v-alert
                                  slot="no-results"
                                  :value="true"
                                  color="error"
                                  icon="warning"
                                >
                                   {{ $t('No-records-searched-for', { value: searchara}) }} 
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false"
              >{{$t('Close')}}</v-btn
            >
          </v-snackbar>

          <v-dialog
            v-model="dialogfiltre"
            scrollable
            persistent
            max-width="400px"
          >
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="Rapor.PPNR_No" hide-details>
                              </pnrbul>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <cariaracomp
                                v-bind:etiket="$t('Currentcode_label')"
                                v-bind:value="Rapor.PCariKod"
                                v-model="Rapor.PCariKod"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select
                                clearable
                                :items="itemssaticitip"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="Rapor.PSaticiTip"
                                :label="$t('Seller-Type')"
                                hide-details=""
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="Rapor.PSaticiTip"
                                :label="$t('Seller-Code')"
                                v-model="Rapor.PSaticiKod"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                hide-details
                                v-model="Rapor.PCariHesapGrubu"
                                :label="$t('Account-Group')"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                hide-details
                                v-model="Rapor.PCariTip"
                                :label="$t('Current-Account-Type')"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                hide-details
                                v-model="Rapor.PSaticiGrup"
                                :label="$t('Seller-Group')"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-select
                                :items="itemsicdis"
                                item-text="text"
                                item-value="value"
                                v-model="Rapor.PSaticiIc_Dis"
                                label="İç Dış"
                                hide-details=""
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama
                                apiname="SaticiAra"
                                :tip="12"
                                :label="$t('Tour-Operator')"
                                v-model="Rapor.PTurOp"
                              >
                              </genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama
                                apiname="SaticiAra"
                                :tip="4"
                                :label="$t('Agency')"
                                v-model="Rapor.PAcente"
                              >
                              </genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                hide-details
                                :items="itemsfaturali"
                                v-model="Rapor.PFaturali"
                                item-text="text"
                                item-value="value"
                                :label="$t('Sales-Invoice')"
                              ></v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-select
                                :items="itemsopsiyon"
                                item-text="text"
                                item-value="value"
                                v-model="Rapor.POpsiyon"
                                :label="$t('Optional-Sales')"
                                hide-details=""
                              >
                              </v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <anatip v-model="Rapor.PAnaTip"></anatip>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <cariaracomp
                                v-bind:etiket="$t('Current-Main-Account')"
                                v-bind:value="Rapor.PCariAnaHesap"
                                v-model="Rapor.PCariAnaHesap"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>
                            <v-flex pl-1 xs12 sm12 md12>
                              <genelarama
                                apiname="MasrafMerkeziAra"
                                :label="$t('Expense-Center-v2')"
                                v-model="Rapor.PMasrafMerkezi"
                              ></genelarama>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <geneltipara
                                v-model="Rapor.PAcenteDepartmanID"
                                tip="AcenteDepartman"
                              >
                              </geneltipara>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                hide-details
                                :items="itemskomisyon"
                                v-model="Rapor.PKomisyonFaturali"
                                item-text="text"
                                item-value="value"
                                :label="$t('Commission-Invoice')"
                              ></v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('Except-Receipt')"
                                v-model="Rapor.PDekontHaric"
                              ></v-checkbox>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('To-be-paid-to-the-hotel-the-guest')"
                                v-model="Rapor.PSatisTip1"
                              >
                              </v-checkbox>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('By-our-Agency-excluding-extras')"
                                v-model="Rapor.PSatisTip2"
                              >
                              </v-checkbox>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('Full-Credit-by-our-Agency')"
                                v-model="Rapor.PSatisTip3"
                              >
                              </v-checkbox>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('By-Tour-Operator')"
                                v-model="Rapor.PSatisTip4"
                              >
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()"
                  >{{$t("cancel_button")}}</v-btn
                >
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()"
                  >{{ $t('Apply-Filters') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-if="iptalDialog" v-model="iptalDialog" max-width="450px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-form ref="formiptal" v-model="valid" lazy-validation>
                    <v-layout class="project overdue" row wrap>
                      <v-flex xs12 pb-2 sm12 md12>
                        <v-layout row wrap>
                          <v-toolbar flat="" size="120px" dark color="white">
                            <v-toolbar-title>
                              <span class="subheading black--text">
                                {{ $t('Details-of-PNR-Cancelled') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-4 xs3 md3 sm3>
                        <span> {{ $t('PNR-No') }} </span>
                      </v-flex>
                      <v-flex xs9 md9 sm9>
                        <span>:{{ secilenKayit.PNR_No }} </span>
                      </v-flex>
                      <v-flex xs3 pl-4 md3 sm3>
                        <span>Cari</span>
                      </v-flex>
                      <v-flex xs9 md9 sm9>
                        <span
                          >:{{ secilenKayit.CariKod }}-{{ secilenKayit.Unvan }}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-flex pl-4 pt-2 xs12 md12 sm12>
                      <v-text-field
                        hide-details
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        v-model="IptalNedeni"
                        :label="$t('Reason-of-Cancellation')"
                      ></v-text-field>
                    </v-flex>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="info"
                  flat="flat"
                  @click.native="iptalDialog = false"
                  >{{$t("cancel_button")}}</v-btn
                >
                <v-btn color="info" flat @click.native="pnrIptal()"
                  >{{ $t('OK') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "../rezervasyon";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";

export default {
  data() {
    return {
      tumsirketler:false,
      tarihTip: 0,
      date1: null,
      date2: null,
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemstarihtip: [
        {
          text: this.$t('Registration-Date'),
          value: 0,
        },
        {
          text: this.$t('Check-in-Date'),
          value: 1,
        },
        {
          text: this.$t('Check-out-Date'),
          value: 2,
        },
        {
          text: this.$t('Sales-Invoice-Date'),
          value: 3,
        },
        {
          text: this.$t('Commission-Invoice-Date'),
          value: 4,
        },
        {
          text: this.$t('Received-Invoice-Date'),
          value: 5,
        },
      ],
      raporTipi: "0",

      itemskomisyon: [
        {
          text: this.$t('None'),
          value: false,
        },
        {
          text: this.$t('Available'),
          value: true,
        },
        {
          text: this.$t('All-v2'),
          value: null,
        },
      ],

      itemsfaturali: [
        {
          text: this.$t('None'),
          value: false,
        },
        {
          text: this.$t('Available'),
          value: true,
        },
        {
          text: this.$t('All-v2'),
          value: null,
        },
      ],
      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      searchara: null,
      IptalNedeni: null,
      iptalDialog: false,
      secilenKayit: {},
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,

      headersdetay: [
        {
          text: this.$t('Company-No'),
          value: "SirketNo",
          width: "5%",
          align: "center",
        },

        {
          text: this.$t('PNR-No'),
          value: "PNR_No",
          width: "5%",
          align: "left",
        },

        {
          text: "Cari Ünvan",
          value: "CariUnvan",
          width: "5%",
          align: "left",
        },

        {
          text: "Satıcı Ad",
          value: "SaticiAd",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Name'),
          value: "Isim",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Night'),
          value: "Gece",
          width: "3%",
          align: "center",
        },
        {
          text: "Satış F/N",
          value: "SatisFaturaNo",
          width: "5%",
          align: "left",
        },
        {
          text: "Satış F/T",
          value: "SatisFaturaTarih",
          width: "5%",
          align: "left",
        },
        {
          text: "Gelen F/N",
          value: "GelenFaturaNo",
          width: "5%",
          align: "left",
        },
        {
          text: "Gelen F/T",
          value: "Gelen Fatura Tarih",
          width: "5%",
          align: "left",
        },
        {
          text: "Iade F/N",
          value: "IadeFaturaNo",
          width: "5%",
          align: "left",
        },
        {
          text: "Iade F/T",
          value: "IadeFaturaTarih",
          width: "5%",
          align: "left",
        },
        {
          text: "Komisyon F/N",
          value: "KomFaturaNo",
          width: "5%",
          align: "left",
        },
        {
          text: "Komisyon F/T",
          value: "KomisyonFaturaTarih",
          width: "5%",
          align: "left",
        },
        {
          text: "Satış Fatura Tutar",
          value: "SatisFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Gelen Fatura Tutar",
          value: "GelenFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Iade Fatura Tutar",
          value: "IadeFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Komisyon Fatura Tutar",
          value: "KomFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Kar KDv'li",
          value: "Kar_KDV_li",
          width: "5%",
          align: "right",
        },
        {
          text: "Kar Yüzde KDv'li",
          value: "Kar_Yuzde_KDV_li",
          width: "5%",
          align: "right",
        },
      ],
      headersozet: [
        {
          text: this.$t('Company-No'),
          value: "SirketNo",
          width: "5%",
          align: "center",
        },

        {
          text: "Cari Ünvan",
          value: "CariUnvan",
          width: "5%",
          align: "left",
        },

        {
          text: this.$t('Night'),
          value: "Gece",
          width: "3%",
          align: "center",
        },

        {
          text: "Satış Fatura Tutar",
          value: "SatisFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Gelen Fatura Tutar",
          value: "GelenFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Iade Fatura Tutar",
          value: "IadeFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Komisyon Fatura Tutar",
          value: "KomFaturaTutar",
          width: "5%",
          align: "right",
        },
        {
          text: "Kar KDv'li",
          value: "Kar_KDV_li",
          width: "5%",
          align: "right",
        },
        {
          text: "Kar Yüzde KDv'li",
          value: "Kar_Yuzde_KDV_li",
          width: "5%",
          align: "right",
        },
      ],

      Rapor: {
        PCariDataBase: null,
        PCariSirket: null,
        PSirketNo: null,
        PPNR_No: null,
        PPNR_ParaBirimi: "TL",
        PKayitTarihBas: null,
        PKayitTarihBit: null,
        PDonem1Bas: null,
        PDonem1Bit: null,
        PDonem2Bas: null,
        PDonem2Bit: null,
        PFatTarihBas: null,
        PFatTarihBit: null,
        PKomFatTarihBas: null,
        PKomFatTarihBit: null,
        PCariKod: null,
        PSaticiTip: null,
        PSaticiKod: null,
        PDosyaTip: null,
        PDosya: null,
        PAcente: null,
        PPNRBir: null,
        PCariHesapGrubu: null,
        PCariTip: null,
        PSaticiGrup: null,
        PSaticiIc_Dis: null,
        PTurOp: null,
        PFaturali: null,
        POpsiyon: 0,
        PAnaTip: 0,
        PCariAnaHesap: null,
        PIptalRaporu: false,
        PSaticiOdemesiHesapla: false,
        PRezGrupID: 0,
        PSatisGrubu: 0,
        PSatisGrupTip: 0,
        PMasrafMerkezi: null,
        PAcenteDepartmanID: 0,
        PDekontHaric: false,
        PSatisTip1: true,
        PSatisTip2: true,
        PSatisTip3: true,
        PSatisTip4: true,
        PGelenFatTarihBas: null,
        PGelenFatTarihBit: null,
        PKomisyonFaturali: null,
        PGelenFaturali: false,
      },

      TurOperatoru: {
        id: null,
        kod: null,
        isim: null,
        tip: 0,
      },
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",

      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      tooltip: false,
      el: null,
      yok: false,
      itemsdetay: [],
      itemsozet: [],

      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => "Lütfen bir tarih seçiniz",
          },
          tarihsec1: {
            required: () => "Lütfen bir tarih seçiniz",
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.el = this.$refs.fab.$el;

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
    pnrbul,
    anatip,
    genelarama,
    referansmerkezicomp,
    geneltipara,
    cariaracomp,
  },
  watch: {},
  methods: {
    pnrIptalDialog(val) {
      this.iptalDialog = true;
      this.IptalNedeni = null;
      this.secilenKayit = val;
    },

    HataYonetimi(response, request, baslik) {
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    git(val) {
      var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
      window.open(url, "_target");
    },
    getList: getList,
    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
    getListExcel,
    getListOzetExcel,
    ParametreOlustur: ParametreOlustur,
    RaporTarihAyarla: RaporTarihAyarla,
  },
};

function filtrele() {
  this.dialogfiltre = true;
}

function filtrekayit() {
  this.filtrevarmi = true;
  this.dialogfiltre = false;
  this.getList();
}

function filtreiptal() {
  this.filtrevarmi = false;
  this.dialogfiltre = false;
  this.Rapor.PPNR_No = null;
  this.Rapor.PCariKod = null;
  this.Rapor.PSaticiTip = null;
  this.Rapor.PSaticiKod = null;
  this.Rapor.PAcente = null;
  this.Rapor.PCariHesapGrubu = null;
  this.Rapor.PCariTip = null;
  this.Rapor.PSaticiGrup = null;
  this.Rapor.PSaticiIc_Dis = null;
  this.Rapor.PTurOp = null;
  this.Rapor.PFaturali = null;
  this.Rapor.POpsiyon = 0;
  this.Rapor.PAnaTip = 0;
  this.Rapor.PCariAnaHesap = null;
  this.Rapor.PMasrafMerkezi = null;
  this.Rapor.PAcenteDepartmanID = 0;
  this.Rapor.PDekontHaric = false;
  this.Rapor.PSatisTip1 = true;
  this.Rapor.PSatisTip2 = true;
  this.Rapor.PSatisTip3 = true;
  this.Rapor.PSatisTip4 = true;
  this.Rapor.PGelenFatTarihBas = null;
  this.Rapor.PGelenFatTarihBit = null;
  this.Rapor.PKomisyonFaturali = null;
  this.tumsirketler = false;

  this.getList();
}

function ParametreOlustur() {
  let RaporParam = {};
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  RaporParam.PKayitTarihBas = this.Rapor.PKayitTarihBas;
  RaporParam.PKayitTarihBit = this.Rapor.PKayitTarihBit;
  RaporParam.PDonem1Bas = this.Rapor.PDonem1Bas;
  RaporParam.PDonem1Bit = this.Rapor.PDonem1Bit;
  RaporParam.PDonem2Bas = this.Rapor.PDonem2Bas;
  RaporParam.PDonem2Bit = this.Rapor.PDonem2Bit;
  RaporParam.PFatTarihBas = this.Rapor.PFatTarihBas;
  RaporParam.PFatTarihBit = this.Rapor.PFatTarihBit;
  RaporParam.PKomFatTarihBas = this.Rapor.PKomFatTarihBas;
  RaporParam.PKomFatTarihBit = this.Rapor.PKomFatTarihBit;
  RaporParam.PGelenFatTarihBas = this.Rapor.PGelenFatTarihBas;
  RaporParam.PGelenFatTarihBit = this.Rapor.PGelenFatTarihBit;
  RaporParam.PSirketNo = credentials.CoperSirketNo;
  RaporParam.PCariSirket = credentials.SirketKodu;
  RaporParam.PPNR_No = this.Rapor.PPNR_No;
  RaporParam.PPNR_ParaBirimi = this.Rapor.PPNR_ParaBirimi;
  RaporParam.PSaticiTip = this.Rapor.PSaticiTip;

  if (this.Rapor.PCariKod != null) {
    RaporParam.PCariKod = this.Rapor.PCariKod.id;
  } else {
    RaporParam.PCariKod = null;
  }

  if (this.Rapor.PSaticiKod != null) {
    RaporParam.PSaticiKod = this.Rapor.PSaticiKod.kod;
  } else {
    RaporParam.PSaticiKod = null;
  }

  if (this.Rapor.PAcente != null) {
    RaporParam.PAcente = this.Rapor.PAcente.kod;
  } else {
    RaporParam.PAcente = this.Rapor.PAcente;
  }

  RaporParam.PCariHesapGrubu = this.Rapor.PCariHesapGrubu;
  RaporParam.PCariTip = this.Rapor.PCariTip;
  RaporParam.PSaticiGrup = this.Rapor.PSaticiGrup;
  RaporParam.PSaticiIc_Dis = this.Rapor.PSaticiIc_Dis;

  if (this.Rapor.PTurOp != null) {
    RaporParam.PTurOp = this.Rapor.PTurOp.kod;
  } else {
    RaporParam.PTurOp = null;
  }

  RaporParam.PFaturali = this.Rapor.PFaturali;

  RaporParam.POpsiyon = this.Rapor.POpsiyon;
  RaporParam.PAnaTip = this.Rapor.PAnaTip;

  if (this.Rapor.PCariAnaHesap != null) {
    RaporParam.PCariAnaHesap = this.Rapor.PCariAnaHesap.id;
  } else {
    RaporParam.PCariAnaHesap = null;
  }

  if (this.Rapor.PCariAnaHesap != null) {
    RaporParam.PCariAnaHesap = this.Rapor.PCariAnaHesap.id;
  } else {
    RaporParam.PCariAnaHesap = null;
  }

  if (this.Rapor.PAcenteDepartmanID != null) {
    RaporParam.PAcenteDepartmanID = this.Rapor.PAcenteDepartmanID.kod;
  } else {
    RaporParam.PAcenteDepartmanID = null;
  }

  if (this.Rapor.PMasrafMerkezi != null) {
    RaporParam.PMasrafMerkezi = this.Rapor.PMasrafMerkezi.kod;
  } else {
    RaporParam.PMasrafMerkezi = null;
  }

  RaporParam.PKomisyonFaturali = this.Rapor.PKomisyonFaturali;

  RaporParam.PSatisTip1 = this.Rapor.PSatisTip1;
  RaporParam.PSatisTip2 = this.Rapor.PSatisTip2;
  RaporParam.PSatisTip3 = this.Rapor.PSatisTip3;
  RaporParam.PSatisTip4 = this.Rapor.PSatisTip4;
  RaporParam.PDekontHaric = this.Rapor.DekontHaric;

  return RaporParam;
}

function RaporTarihAyarla() {
  if (this.tarihTip == 0) {
    this.Rapor.PKayitTarihBas = this.KayitTarihiBasla;
    this.Rapor.PKayitTarihBit = this.KayitTarihiBitis;

    this.Rapor.PDonem1Bas = null;
    this.Rapor.PDonem1Bit = null;

    this.Rapor.PDonem2Bas = null;
    this.Rapor.PDonem2Bit = null;

    this.Rapor.PFatTarihBas = null;
    this.Rapor.PFatTarihBit = null;

    this.Rapor.PKomFatTarihBas = null;
    this.Rapor.PKomFatTarihBit = null;

    this.Rapor.PGelenFatTarihBas = null;
    this.Rapor.PGelenFatTarihBit = null;
  } else if (this.tarihTip == 1) {
    this.Rapor.PKayitTarihBas = null;
    this.Rapor.PKayitTarihBit = null;

    this.Rapor.PDonem1Bas = this.KayitTarihiBasla;
    this.Rapor.PDonem1Bit = this.KayitTarihiBitis;

    this.Rapor.PDonem2Bas = null;
    this.Rapor.PDonem2Bit = null;

    this.Rapor.PFatTarihBas = null;
    this.Rapor.PFatTarihBit = null;

    this.Rapor.PKomFatTarihBas = null;
    this.Rapor.PKomFatTarihBit = null;

    this.Rapor.PGelenFatTarihBas = null;
    this.Rapor.PGelenFatTarihBit = null;
  } else if (this.tarihTip == 2) {
    this.Rapor.PKayitTarihBas = null;
    this.Rapor.PKayitTarihBit = null;

    this.Rapor.PDonem1Bas = null;
    this.Rapor.PDonem1Bit = null;

    this.Rapor.PDonem2Bas = this.KayitTarihiBasla;
    this.Rapor.PDonem2Bit = this.KayitTarihiBitis;

    this.Rapor.PFatTarihBas = null;
    this.Rapor.PFatTarihBit = null;

    this.Rapor.PKomFatTarihBas = null;
    this.Rapor.PKomFatTarihBit = null;

    this.Rapor.PGelenFatTarihBas = null;
    this.Rapor.PGelenFatTarihBit = null;
  } else if (this.tarihTip == 3) {
    this.Rapor.PKayitTarihBas = null;
    this.Rapor.PKayitTarihBit = null;

    this.Rapor.PDonem1Bas = null;
    this.Rapor.PDonem1Bit = null;

    this.Rapor.PDonem2Bas = null;
    this.Rapor.PDonem2Bit = null;

    this.Rapor.PFatTarihBas = this.KayitTarihiBasla;
    this.Rapor.PFatTarihBit = this.KayitTarihiBitis;

    this.Rapor.PKomFatTarihBas = null;
    this.Rapor.PKomFatTarihBit = null;

    this.Rapor.PGelenFatTarihBas = null;
    this.Rapor.PGelenFatTarihBit = null;
  } else if (this.tarihTip == 4) {
    this.Rapor.PKayitTarihBas = null;
    this.Rapor.PKayitTarihBit = null;

    this.Rapor.PDonem1Bas = null;
    this.Rapor.PDonem1Bit = null;

    this.Rapor.PDonem2Bas = null;
    this.Rapor.PDonem2Bit = null;

    this.Rapor.PFatTarihBas = null;
    this.Rapor.PFatTarihBit = null;

    this.Rapor.PKomFatTarihBas = this.KayitTarihiBasla;
    this.Rapor.PKomFatTarihBit = this.KayitTarihiBitis;

    this.Rapor.PGelenFatTarihBas = null;
    this.Rapor.PGelenFatTarihBit = null;
  } else if (this.tarihTip == 5) {
    this.Rapor.PKayitTarihBas = null;
    this.Rapor.PKayitTarihBit = null;

    this.Rapor.PDonem1Bas = null;
    this.Rapor.PDonem1Bit = null;

    this.Rapor.PDonem2Bas = null;
    this.Rapor.PDonem2Bit = null;

    this.Rapor.PFatTarihBas = null;
    this.Rapor.PFatTarihBit = null;

    this.Rapor.PKomFatTarihBas = null;
    this.Rapor.PKomFatTarihBit = null;

    this.Rapor.PGelenFatTarihBas = this.KayitTarihiBasla;
    this.Rapor.PGelenFatTarihBit = this.KayitTarihiBitis;
  }

  return;
}

function getList() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

    this.RaporTarihAyarla();

    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

      let params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi:this.$route.name
      };

      if (this.raporTipi == 0) {
        tool.http_post(this, "KarlilikRaporu", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.itemsdetay = response.body.data;

              this.progress = false;
              this.load1 = true;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
            }
          },
          (response) => {
            this.HataYonetimi(response, params, "Karlılık Raporu Getirilemedi");
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        tool.http_post(this, "KarlilikRaporuOzet", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.itemsozet = response.body.data;

              this.progress = false;
              this.load1 = true;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
            }
          },
          (response) => {
            this.HataYonetimi(response, params, "Karlılık Raporu Getirilemedi");
            this.progress = false;
            this.load1 = true;
          }
        );
      }
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}

function getListExcel() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

    this.RaporTarihAyarla();

    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

      let params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi:this.$route.name
      };

      tool
        .api_post_FileDownload(this, "Coper/ExcelKarlilikRaporu", params)
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx",
            });

            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "KarlilikRaporu.xlsx";
            link.click();
            this.progress = false;
            this.load1 = true;
          },

          (response) => {
            this.progress = false;
            this.load1 = true;
          }
        );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}

function getListOzetExcel() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

    this.RaporTarihAyarla();

    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

      let params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi:this.$route.name
      };

      tool
        .api_post_FileDownload(this, "Coper/ExcelKarlilikRaporuOzet", params)
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx",
            });

            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "OzetKarlilikRaporu.xlsx";
            link.click();
            this.progress = false;
            this.load1 = true;
          },

          (response) => {
            this.progress = false;
            this.load1 = true;
          }
        );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}

function beforeMount() {}
</script>
<style>
</style>